import { combineReducers } from 'redux';
import dealers from './dealers';
import filters from './filters';

export default combineReducers({ dealers, filters });
